<!-- 在线人数和热度 -->
<template>
  <transition name="fade">
    <div class="online-hot" v-if="showPerson || showHot">
      <!-- 在线人数 -->
      <div class="online-hot__item" v-if="showPerson">
        <i class="vh-iconfont vh-line-user"></i>
        <span class="text-count">{{ personCount | formatHotNum }}</span>
      </div>
      <!-- 热度 -->
      <div class="online-hot__item" v-if="showHot">
        <i class="vh-saas-iconfont vh-saas-line-heat"></i>
        <span class="text-count">{{ hotNum | formatHotNum }}</span>
      </div>
    </div>
  </transition>
</template>
<script>
  import { throttle } from 'lodash';
  export default {
    name: 'OnlineHot',
    computed: {
      watchInitData() {
        return this?.$domainStore?.state?.roomBaseServer?.watchInitData;
      },
      // 在线人数或订阅人数 Type:String
      personCount() {
        return (
          Number(
            this.$domainStore.state.virtualAudienceServer.virtual_type == 5
              ? 0
              : this.$domainStore.state.virtualAudienceServer.uvOnline
          ) + Number(this.$domainStore.state.virtualAudienceServer.virtualOnline)
        );
      },
      hotNum() {
        return (
          Number(
            this.$domainStore.state.virtualAudienceServer.virtual_type == 5
              ? 0
              : this.$domainStore.state.virtualAudienceServer.uvHot
          ) +
          Number(this.$domainStore.state.virtualAudienceServer.virtualHot) +
          1
        );
      },

      // 是否在线人数
      showPerson() {
        return this.watchInitData.status != 'subscribe' && this.watchInitData?.online?.show;
      },
      // 是否显示热度
      showHot() {
        return !!this.watchInitData?.pv?.show;
      }
    }
  };
</script>
<style lang="less">
  .online-hot {
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 8;
    display: inline-flex;
    border-radius: 32px;
    padding: 2px 12px;
    background: rgba(0, 0, 0, 0.5);
    align-items: center;

    &__item {
      display: inline-flex;
      align-items: center;
      color: #fff;

      i {
        font-size: 12px;
      }
      .text-count {
        font-size: 14px;
        line-height: 22px;
        margin-left: 6px;
      }

      & + & {
        margin-left: 12px;
      }
    }
  }
</style>
